// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2826":"css/app.6993","7464":"css/admin-app.6993"}[chunkId] + ".css";
};